  import classnames from "classnames";

type TSpinnerChase = {
  className?: string;
}

const SpinnerChase = (props: TSpinnerChase) => {

  return <div className={classnames('spinner-chase', props.className)}>
    <div className="chase-dot" />
    <div className="chase-dot" />
    <div className="chase-dot" />
    <div className="chase-dot" />
    <div className="chase-dot" />
    <div className="chase-dot" />
  </div>
}

export default SpinnerChase;